import React from 'react';
import { TextRectangle, Label, IconMail, TransparentIconMail } from './components';
import { picDim, nodeWidth } from '../../library/constants';
import { isMobilePhone
} from '../../library/calc';
import './index.css';

export default ({
    node,
    nodeObj,
    left,
    top,
    onClickedInvite,
    cursorBecomesMove,
    cursorBecomesPointer,
    invitationImage,
    canEditnode,
    stopStageClickPropagation,
    userTouchedNode,
    panAnimateToNode,
    translatedLabels,
    setFlipCardScreenIsOn,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
    isPedigree,
    pedigreeIsTall,
    buildRefObj,
    callRefObj,
  }) => {

  const mailIconDim = {
    width: 4.2,
    height: 4.2,
  }

  const picMargin = 2;
  let widthInviteContainer = ( !canEditnode({nodeObj}) ? 31.5 : 27.5);
  widthInviteContainer = widthInviteContainer - 2;
  if(isMobilePhone()) widthInviteContainer = 40;

  const picAreaWidth = (picMargin * 2) + picDim;
  const contentAreaWidth = nodeWidth - picAreaWidth;
  const pullLeftbuffer = 9.2;

  const useThisTranslatedWidthToAccomodateInviteButtonsWithNoLabels =
    ( isPedigree && !pedigreeIsTall ? 15 : translatedLabels.invite.translatedWidth)

  const inviteContainerPaddingLeft =
    ((contentAreaWidth - useThisTranslatedWidthToAccomodateInviteButtonsWithNoLabels)  /  2) -
    pullLeftbuffer;

  if(isPedigree) {
    top -= 8.2;
    left -= 3;
    if(!pedigreeIsTall) {
      top -= 5.6;
      left += 20.5;
    }
  }

  const props = {
    node,
    nodeObj,
    left,
    top,
    onClickedInvite,
    cursorBecomesMove,
    cursorBecomesPointer,
    canEditnode,
    stopStageClickPropagation,
    userTouchedNode,
    panAnimateToNode,
    translatedLabels,
    mailIconDim,
    widthInviteContainer,
    inviteContainerPaddingLeft,
    setFlipCardScreenIsOn,
    setNodeForFlipFocus,
    setShowMobileFlipCard,
    buildRefObj,
    callRefObj,
  };

  if(node < 0) return [];

  let combinedComponents = [
    <TextRectangle key={Math.random()} {...props} />,
    <Label key={Math.random()} {...props} />,
    <IconMail
      key={Math.random()}
      invitationImage={invitationImage}
      {...props}/>,
  ]

  if(isPedigree && !pedigreeIsTall) {
    delete combinedComponents[0];
    delete combinedComponents[1];
    combinedComponents.push(
      <TransparentIconMail
        key={Math.random()}
        invitationImage={invitationImage}
        {...props}/>,
    );
  }

  return combinedComponents;
};

